module.exports = __webpack_public_path__ + "img/home-fqa-bg.e810368b.svg";